import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { type AudienceSegmentTagGroupOperator, audienceSegmentTagGroupOperator } from '../../constants.ts';
import { useDealPromptDomainsContext } from '../../utils/context/DealPromptDomainsContext.tsx';
import { LogicalSeparator } from './LogicalSeparator.tsx';
import { MoreGroupsItem } from './MoreGroupsItem.tsx';
import { TagGroupDisplay } from './TagGroupDisplay.tsx';

export const DealPromptAudienceComposition = () => {
  const { generatedSearchInput } = useDealPromptDomainsContext();
  const { t } = useTranslation();
  const groups = generatedSearchInput?.tagGroups.groups || [];
  const hasTags = groups.some(group => group.tags?.length > 0);

  if (!hasTags) {
    return null;
  }

  const rawOperator = generatedSearchInput?.tagGroups.operator;
  const operator: AudienceSegmentTagGroupOperator =
    rawOperator === audienceSegmentTagGroupOperator.OR
      ? audienceSegmentTagGroupOperator.OR
      : audienceSegmentTagGroupOperator.AND;
  const additionalGroups = groups ? groups.length - 3 : 0;
  const onlyFirstThreeGroups = additionalGroups > 0 ? groups.slice(0, 3) : groups;

  return (
    <Stack
      direction="column"
      sx={{
        gap: 1.5,
      }}
    >
      <Divider />
      <Stack
        direction="row"
        sx={{
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="body1Bold">{t('Audience Composition - Match Rules')}</Typography>
      </Stack>
      {onlyFirstThreeGroups.length > 0 && (
        <Stack
          direction="row"
          sx={{
            flexWrap: 'nowrap',
            gap: 2,
          }}
        >
          {onlyFirstThreeGroups.map((group, index) => (
            <TagGroupDisplay key={index} group={group} groupIndex={index} hideOpeartors={groups.length > 2} />
          ))}
          {additionalGroups > 0 && <MoreGroupsItem additionalGroups={additionalGroups} />}
        </Stack>
      )}
      {groups.length > 1 && (
        <Stack
          direction="row"
          sx={{
            width: '100%',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Typography variant="body2" sx={{ mr: 1, color: 'text.secondary' }}>
            {t('Connection between Groups:')}
          </Typography>
          <LogicalSeparator variant={operator} />
        </Stack>
      )}
    </Stack>
  );
};
